import React, { useState, useEffect } from 'react';
import { getStories } from '../services/api';
import StoryCard from '../components/StoryCard';
import { BookOpen } from 'lucide-react';

const Fiction = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFiction = async () => {
      try {
        const data = await getStories('fiction');
        setStories(data);
      } catch (error) {
        console.error('Error fetching fiction:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFiction();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }
  return (
    <div className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-16 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <BookOpen size={32} className="text-gray-900" />
            <h1 className="text-4xl md:text-5xl font-serif text-gray-900">Fiction</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Stories that explore the boundaries between the known and unknown,
            where reality bends and the impossible feels inevitable.
          </p>
        </div>

        <div>
          {stories.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fiction;